var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelValidation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 429,
    viewBox: "0 0 512 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.26 267.975L120.103 273.056C120.998 273.57 121.994 273.882 123.022 273.972C124.049 274.061 125.084 273.925 126.054 273.574C127.024 273.222 127.906 272.663 128.638 271.936C129.369 271.209 129.934 270.331 130.292 269.363C130.677 268.322 130.812 267.204 130.686 266.101C130.561 264.997 130.178 263.939 129.568 263.011C128.959 262.082 128.14 261.31 127.177 260.756C126.215 260.202 125.136 259.882 124.027 259.821L113.319 259.232L81.0658 249.469L75.8654 230L62.2695 237.638L71.6191 259.772L111.262 267.974L111.26 267.975Z",
    fill: "#FFB8B8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7412 167.781C67.6551 170.145 68.0317 172.99 69.5514 175.299C71.07 177.608 73.5976 179.529 75.8096 181.565C77.2313 182.874 78.5456 184.263 79.1832 185.838C79.5334 186.644 79.6478 187.532 79.513 188.399C79.3782 189.267 78.9998 190.078 78.4218 190.739C76.9733 192.454 74.2744 193.613 71.6426 194.608C64.1134 197.433 56.3446 199.573 48.4307 201.001C55.0974 193.212 58.4339 184.438 57.9459 175.988C57.8427 174.214 57.5797 172.424 58.1987 170.648C58.624 169.58 59.2967 168.629 60.1613 167.873C61.026 167.116 62.058 166.575 63.1724 166.295C65.8218 165.535 69.312 166.287 69.7185 168.023L69.7412 167.781Z",
    fill: "#2F2E41"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1372 410.595L23.4608 411L41.8619 326L25.8928 326.686L14.1362 410.595H14.1372Z",
    fill: "#FFB8B8"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.001 392.641L99.2819 396.703L51.001 325.07L66.3755 318.297L107.001 392.641Z",
    fill: "#FFB8B8"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5 194.999C45.2044 194.999 38.5005 188.294 38.5005 179.999C38.5005 171.703 45.2044 165 53.5 165C61.7945 165 68.4995 171.704 68.4995 179.999C68.4995 188.294 61.7945 194.999 53.5 194.999Z",
    fill: "#FFB8B8"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9746 187.129C45.9746 187.129 40.6605 198.167 33.3014 197.758C33.3014 197.758 19.4019 192.034 14.9054 207.569L10 219.833L75 230.871C75 230.871 71.319 208.386 62.7356 207.977C62.7356 207.977 52.9239 207.159 54.1502 203.48C55.3776 199.801 59.8741 191.217 59.8741 191.217L45.9746 187.129Z",
    fill: "#FFB8B8"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4245 242.919L57.7359 263.912L65.7203 297.844L104.611 370.83C104.611 370.83 86.7002 386.898 82.2355 389.476C78.3623 391.712 46.1212 331.112 44.9433 318.621C44.5556 314.499 37.485 398 37.485 398C37.485 398 10.8333 393.602 3.39014 392.139C3.39014 392.139 8.75261 354.16 11.9139 318.621C14.3511 291.227 12.1348 266.401 25.8422 254.626L24.6311 231.212L56.9275 230L67.4245 242.919Z",
    fill: "#2F2E41"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.694 426.14L32.0861 428.375C32.6124 428.942 33.2601 429.382 33.9807 429.663C34.7012 429.943 35.476 430.057 36.2468 429.996C37.0177 429.935 37.7646 429.7 38.4317 429.308C39.0988 428.917 39.6687 428.38 40.0986 427.737C40.5286 427.095 40.8075 426.363 40.9144 425.597C41.0213 424.831 40.9534 424.051 40.7159 423.315C40.4784 422.579 40.0774 421.907 39.5429 421.348C39.0084 420.789 38.3544 420.358 37.6298 420.088L31.0954 413.051L26.3933 402.904C23.5819 400.031 21.6599 401.048 20.5848 405.767L13.0649 403.406L11.096 416.656C10.8013 418.639 11.1966 420.663 12.2156 422.389C13.2346 424.116 14.8156 425.44 16.694 426.14Z",
    fill: "#2F2E41"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.011 412.919L116.743 412.864C117.353 413.353 118.067 413.697 118.83 413.871C119.592 414.045 120.384 414.044 121.147 413.868C121.909 413.692 122.621 413.345 123.231 412.855C123.84 412.364 124.33 411.742 124.665 411.035C124.999 410.328 125.169 409.554 125.162 408.772C125.155 407.989 124.971 407.219 124.623 406.518C124.276 405.817 123.774 405.204 123.156 404.725C122.538 404.245 121.819 403.912 121.054 403.75L113.471 397.682L107.257 388.233C104.017 385.775 102.245 387.079 101.872 391.96L94 390.717V404.265C93.9998 406.292 94.6961 408.258 95.9723 409.834C97.2484 411.409 99.0281 412.498 101.011 412.919Z",
    fill: "#2F2E41"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1569 157.056C43.6131 155.946 40.5882 156.381 38.1315 157.676C35.6767 158.969 33.7144 161.033 31.9977 163.213C26.0863 170.758 22.639 179.939 22.1236 189.51C21.9895 192.13 22.1154 194.894 23.4779 197.133C24.9745 199.592 27.7148 201.004 30.4285 201.965C39.5273 205.136 49.5099 204.587 58.2063 200.438C53.6336 196.73 49.4026 192.619 45.5642 188.156C44.8446 187.319 44.0932 186.246 44.4586 185.205C44.689 184.698 45.0461 184.259 45.4956 183.931L54.3103 176.276L54.0881 179.374C55.8414 179.272 57.5262 178.658 58.9343 177.608C60.3425 176.559 61.4121 175.119 62.0112 173.468C61.5864 174.326 62.3971 175.38 63.3348 175.573C64.2724 175.765 65.2224 175.379 66.1017 175.001C68.234 174.083 70.5505 172.99 71.4963 170.869C71.7943 170.122 71.9369 169.322 71.9156 168.518C71.8944 167.713 71.7095 166.922 71.3725 166.191C70.6881 164.733 69.7115 163.431 68.5032 162.366C65.5384 159.629 61.9313 157.684 58.0155 156.711C54.0998 155.737 50.0018 155.767 46.1006 156.797L46.1569 157.056Z",
    fill: "#2F2E41"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0319 265.639L49.4835 273.444C50.1363 274.234 50.9536 274.872 51.8783 275.313C52.8029 275.755 53.8128 275.989 54.8374 276C55.862 276.011 56.8766 275.798 57.8105 275.377C58.7445 274.955 59.5752 274.335 60.2449 273.56C60.9659 272.725 61.4809 271.733 61.7484 270.664C62.0159 269.594 62.0285 268.476 61.7852 267.4C61.5418 266.325 61.0493 265.321 60.3473 264.471C59.6453 263.621 58.7534 262.947 57.7434 262.504L47.9917 258.227L21.4007 237.914L23.3486 218.001L8.04346 220.367L9.02797 244.206L43.0319 265.639Z",
    fill: "#FFB8B8"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 248.019C83 248.019 76.7262 225.043 73.4169 225.049C70.1066 225.054 65.6748 224.65 65.6748 224.65C65.6748 224.65 60.4383 209.34 33.4417 214.175C6.44722 219.009 18.131 209.743 10.4761 213.369C2.82022 216.995 0 242.379 0 242.379C0 242.379 41.5005 228.679 50.364 236.336C55.4544 240.788 60.9902 244.703 66.8835 248.019C66.8835 248.019 62.8546 258.093 83 248.019Z",
    fill: "#2F2E41"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 411.468H227.001V412.533H64V411.469V411.468Z",
    fill: "#3F3D56"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.5 228.5C297.029 228.5 253 184.471 253 130.001C253 75.5299 297.029 31.5 351.5 31.5C405.971 31.5 450 75.5289 450 130.001C450 184.47 405.971 228.5 351.5 228.5Z",
    fill: "#E6E6E6"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.999 75.4678H333V76.5331H169.999V75.4678Z",
    fill: "#3F3D56"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.999 104.467H490V105.532H169.999V104.467Z",
    fill: "#3F3D56"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391 209C336.411 209 292 164.588 292 110C292 55.4108 336.412 11 391 11C445.589 11 490 55.4108 490 110C490 164.589 445.588 209 391 209ZM391 12.0635C337 12.0645 293.065 55.9987 293.065 110.001C293.065 164.003 337 207.937 391.001 207.937C445.003 207.937 488.937 164.002 488.937 110.001C488.937 55.9987 445.002 12.0655 391.001 12.0655L391 12.0635Z",
    fill: "#3F3D56"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.501 27C379.727 27.0019 377.971 26.654 376.332 25.9762C374.693 25.2983 373.204 24.3039 371.95 23.0498C370.696 21.7957 369.701 20.3065 369.023 18.6675C368.346 17.0286 367.998 15.272 368 13.4984C368.001 6.03439 374.034 5.80256e-06 381.5 5.80256e-06C383.273 -0.00163901 385.029 0.346413 386.668 1.02424C388.307 1.70207 389.795 2.69637 391.049 3.95024C392.303 5.20411 393.297 6.69294 393.975 8.33151C394.653 9.97009 395.001 11.7262 395 13.4995C395 20.9656 388.967 27 381.501 27Z",
    fill: "#2751A5"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293 112C291.818 112.001 290.647 111.769 289.555 111.317C288.462 110.865 287.469 110.202 286.634 109.366C285.798 108.531 285.135 107.538 284.683 106.445C284.231 105.353 283.999 104.182 284 103C283.999 101.818 284.231 100.647 284.683 99.5547C285.135 98.4623 285.798 97.4698 286.634 96.6338C287.47 95.7979 288.462 95.135 289.555 94.6831C290.647 94.2311 291.818 93.999 293 94C294.182 93.999 295.353 94.2311 296.445 94.6831C297.537 95.1351 298.53 95.798 299.366 96.6339C300.202 97.4698 300.864 98.4624 301.316 99.5548C301.768 100.647 302 101.818 301.999 103C302 104.182 301.768 105.353 301.316 106.445C300.864 107.538 300.201 108.531 299.365 109.366C298.529 110.202 297.537 110.865 296.444 111.317C295.352 111.769 294.181 112.001 292.999 112H293Z",
    fill: "#0BB7A7"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.501 123C481.717 123 473 114.284 473 103.501C473 92.7159 481.717 84 492.501 84C503.284 84 512 92.7169 512 103.501C512 114.284 503.284 123 492.501 123Z",
    fill: "#2751A5"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.006 179.006H165.182V180.08H224.006C230.037 180.08 234.926 184.969 234.926 191.001C234.926 197.032 230.037 201.92 224.006 201.92H134.994C128.963 201.92 124.074 197.032 124.074 191.001C124.074 184.969 128.963 180.08 134.994 180.08H138.32V179.007H134.994C128.37 179.006 123 184.376 123 191C123 197.623 128.37 202.994 134.994 202.994H224.006C230.63 202.994 236 197.624 236 191C236 184.375 230.63 179.005 224.006 179.005V179.006Z",
    fill: "#3F3D56"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.006 215.506H165.182V216.579H224.006C230.037 216.579 234.926 221.469 234.926 227.5C234.926 233.531 230.037 238.42 224.006 238.42H134.994C128.963 238.42 124.074 233.531 124.074 227.5C124.074 221.469 128.963 216.58 134.994 216.58H138.32V215.506H134.994C128.37 215.506 123 220.876 123 227.5C123 234.124 128.37 239.494 134.994 239.494H224.006C230.63 239.494 236 234.124 236 227.5C236 220.876 230.63 215.506 224.006 215.506Z",
    fill: "#3F3D56"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.006 252.006H165.182V253.08H224.006C230.037 253.08 234.926 257.969 234.926 264C234.926 270.031 230.037 274.92 224.006 274.92H134.994C128.963 274.92 124.074 270.031 124.074 264C124.074 257.969 128.963 253.08 134.994 253.08H138.32V252.006H134.994C128.37 252.006 123 257.376 123 264C123 270.624 128.37 275.994 134.994 275.994H224.006C230.63 275.994 236 270.624 236 264C236 257.376 230.63 252.006 224.006 252.006Z",
    fill: "#3F3D56"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.28 176.221C144.41 176.221 143.576 176.566 142.961 177.181C142.346 177.796 142 178.631 142 179.5C142 180.37 142.346 181.205 142.961 181.82C143.576 182.435 144.41 182.78 145.28 182.78H159.666C160.536 182.78 161.37 182.435 161.985 181.82C162.6 181.205 162.946 180.37 162.946 179.5C162.946 178.631 162.6 177.796 161.985 177.181C161.37 176.566 160.536 176.221 159.666 176.221H145.28Z",
    fill: "#2751A5"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.28 213.221C144.41 213.221 143.576 213.566 142.961 214.181C142.346 214.796 142 215.631 142 216.501C142 217.37 142.346 218.205 142.961 218.82C143.576 219.435 144.41 219.78 145.28 219.78L159.666 219.779C160.102 219.787 160.534 219.708 160.939 219.547C161.344 219.385 161.712 219.145 162.023 218.84C162.334 218.534 162.581 218.17 162.749 217.769C162.918 217.367 163.004 216.936 163.004 216.5C163.004 216.064 162.918 215.633 162.749 215.231C162.581 214.83 162.334 214.466 162.023 214.16C161.712 213.855 161.344 213.615 160.939 213.453C160.534 213.292 160.102 213.213 159.666 213.221H145.28Z",
    fill: "#0BB7A7"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.28 249.222C144.41 249.222 143.576 249.567 142.961 250.182C142.346 250.797 142 251.632 142 252.502C142 253.371 142.346 254.206 142.961 254.821C143.576 255.436 144.41 255.781 145.28 255.781L159.666 255.78C160.536 255.78 161.37 255.435 161.985 254.82C162.6 254.205 162.946 253.37 162.946 252.5C162.946 251.631 162.6 250.796 161.985 250.181C161.37 249.566 160.536 249.221 159.666 249.221H145.28V249.222Z",
    fill: "#3F3D56"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip52_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.211 187.788C138.359 187.788 137.542 188.127 136.94 188.729C136.337 189.331 135.999 190.148 135.999 191C135.999 191.852 136.337 192.669 136.94 193.272C137.542 193.874 138.359 194.212 139.211 194.212H219.735C220.587 194.212 221.404 193.874 222.006 193.272C222.609 192.669 222.947 191.852 222.947 191C222.947 190.148 222.609 189.331 222.006 188.729C221.404 188.127 220.587 187.788 219.735 187.788H139.211Z",
    fill: "#E6E6E6"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip54_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.211 224.288C138.359 224.288 137.542 224.627 136.94 225.229C136.337 225.831 135.999 226.648 135.999 227.5C135.999 228.352 136.337 229.169 136.94 229.772C137.542 230.374 138.359 230.712 139.211 230.712H219.735C220.587 230.712 221.404 230.374 222.006 229.772C222.609 229.169 222.947 228.352 222.947 227.5C222.947 226.648 222.609 225.831 222.006 225.229C221.404 224.627 220.587 224.288 219.735 224.288H139.211Z",
    fill: "#E6E6E6"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip56_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.211 260.789C138.359 260.789 137.542 261.128 136.94 261.73C136.337 262.332 135.999 263.149 135.999 264.001C135.999 264.853 136.337 265.67 136.94 266.273C137.542 266.875 138.359 267.213 139.211 267.213L219.735 267.212C220.587 267.212 221.404 266.874 222.006 266.272C222.609 265.669 222.947 264.852 222.947 264C222.947 263.148 222.609 262.331 222.006 261.729C221.404 261.127 220.587 260.788 219.735 260.788L139.211 260.789Z",
    fill: "#E6E6E6"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip58_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.598 379.274C219.768 373.919 218.148 368.718 215.791 363.84L215.447 363.128L212.895 365.959L214.786 361.744L214.663 361.499C212.994 358.196 211.145 354.987 209.123 351.887L208.748 351.313L208.248 351.867L208.598 351.087L208.422 350.824C205.918 347.068 203.995 344.693 203.976 344.67L203.432 344L203.082 344.798C203.018 344.944 196.659 359.594 195.817 374.071L195.804 374.297L200.083 379.469L195.72 376.729L195.728 377.725C195.741 379.426 195.857 381.125 196.074 382.812C196.266 384.263 196.492 385.681 196.752 387.064C197.165 387.076 197.566 387.201 197.913 387.426C197.611 385.881 197.351 384.292 197.133 382.662C196.964 381.353 196.858 380.037 196.816 378.718L205.257 384.017L196.898 373.913C197.66 361.674 202.383 349.342 203.709 346.088C204.421 347.01 205.763 348.802 207.369 351.196L204.451 357.705L208.614 353.089C210.418 355.898 212.081 358.796 213.594 361.773L209.098 371.795L215.176 365.054C217.3 369.62 218.77 374.463 219.543 379.439C220.606 387.475 220.399 395.195 218.958 401.178C217.578 406.909 215.144 410.431 212.283 410.843C211.694 410.924 211.095 410.889 210.519 410.738C210.058 411.065 209.503 411.235 208.938 411.22H208.781C209.669 411.713 210.664 411.98 211.68 411.999C211.929 411.999 212.18 411.981 212.428 411.945C215.793 411.461 218.48 407.734 219.994 401.45C221.468 395.331 221.684 387.46 220.599 379.273L220.598 379.274Z",
    fill: "#3F3D56"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip60_711_38667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61_711_38667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.149 411.916C206.672 411.916 200.216 409.453 193.813 404.969C192.871 404.304 191.971 403.58 191.118 402.803L190.401 402.147L193.113 401.367L189.503 401.234L189.351 401.075C182.582 393.987 178.371 383.976 178.329 383.875L178.001 383.084L178.856 383.123C178.941 383.128 180.976 383.223 184.033 383.656L184.224 383.684V383.682L184.895 383.784C187.391 384.163 189.864 384.684 192.303 385.342L192.563 385.411L193.377 387.416L193.254 385.618L194 385.834C197.537 386.855 200.897 388.413 203.962 390.453C213.7 397.272 219.088 405.794 216.24 409.86C215.266 411.251 213.473 411.915 211.149 411.916ZM192.59 402.649C193.184 403.153 193.804 403.633 194.438 404.079C203.357 410.325 212.933 412.686 215.349 409.237C217.764 405.789 212.269 397.598 203.35 391.351C200.598 389.521 197.6 388.09 194.445 387.103L194.927 394.125L191.759 386.321C189.663 385.766 187.541 385.313 185.401 384.965L185.751 390.06L183.571 384.69C182.282 384.512 180.989 384.371 179.692 384.268C180.821 386.748 184.553 394.407 189.985 400.164L199.949 400.529L192.59 402.649Z",
    fill: "#3F3D56"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 44,
    fill: "white",
    transform: "translate(62 230)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 44,
    fill: "white",
    transform: "translate(62 230)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 35,
    fill: "white",
    transform: "translate(48 166)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 35,
    fill: "white",
    transform: "translate(48 166)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 85,
    fill: "white",
    transform: "translate(14 326)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 85,
    fill: "white",
    transform: "translate(13.9995 326)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 79,
    fill: "white",
    transform: "translate(51 318)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 79,
    fill: "white",
    transform: "translate(51 318)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    fill: "white",
    transform: "translate(38 165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    fill: "white",
    transform: "translate(38 165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 44,
    fill: "white",
    transform: "translate(10 187)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 44,
    fill: "white",
    transform: "translate(10 187)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 168,
    fill: "white",
    transform: "translate(3 230)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 168,
    fill: "white",
    transform: "translate(3.00049 230)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(11 401)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(11 401)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 26,
    fill: "white",
    transform: "translate(94 387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 26,
    fill: "white",
    transform: "translate(94 387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 48,
    fill: "white",
    transform: "translate(22 156)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 48,
    fill: "white",
    transform: "translate(22 156)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 58,
    fill: "white",
    transform: "translate(8 218)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 58,
    fill: "white",
    transform: "translate(8 218)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 41,
    fill: "white",
    transform: "translate(0 212)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 41,
    fill: "white",
    transform: "translate(0 212)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 2,
    fill: "white",
    transform: "translate(64 411)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 2,
    fill: "white",
    transform: "translate(64 411)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 198,
    fill: "white",
    transform: "translate(253 31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 198,
    fill: "white",
    transform: "translate(253 31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 2,
    fill: "white",
    transform: "translate(170 75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 2,
    fill: "white",
    transform: "translate(170 75.0005)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 2,
    fill: "white",
    transform: "translate(170 104)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 2,
    fill: "white",
    transform: "translate(170 104)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 198,
    fill: "white",
    transform: "translate(292 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 198,
    fill: "white",
    transform: "translate(292 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(368)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(368)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(284 94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(284 94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(473 84)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(473 84)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 24,
    fill: "white",
    transform: "translate(123 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 24,
    fill: "white",
    transform: "translate(123 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 25,
    fill: "white",
    transform: "translate(123 215)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 25,
    fill: "white",
    transform: "translate(123 215)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 24,
    fill: "white",
    transform: "translate(123 252)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 24,
    fill: "white",
    transform: "translate(123 252)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 7,
    fill: "white",
    transform: "translate(142 176)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 7,
    fill: "white",
    transform: "translate(142 176)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 7,
    fill: "white",
    transform: "translate(142 213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 7,
    fill: "white",
    transform: "translate(142 213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 7,
    fill: "white",
    transform: "translate(142 249)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 7,
    fill: "white",
    transform: "translate(142 249)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    fill: "white",
    transform: "translate(136 187)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    fill: "white",
    transform: "translate(136 187)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 7,
    fill: "white",
    transform: "translate(136 224)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 7,
    fill: "white",
    transform: "translate(136 224)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    fill: "white",
    transform: "translate(136 260)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    fill: "white",
    transform: "translate(136 260)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 68,
    fill: "white",
    transform: "translate(195 344)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 68,
    fill: "white",
    transform: "translate(195 344)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 29,
    fill: "white",
    transform: "translate(178 383)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61_711_38667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 29,
    fill: "white",
    transform: "translate(178 383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelValidation);
export default __webpack_public_path__ + "static/media/ModelValidation.53ed4a03792be94515e0abfcf12db650.svg";
export { ForwardRef as ReactComponent };